import CoreHeroFeaturedContent from './CoreHeroFeaturedContent';

export { type CoreHeroFeaturedContentProps } from './CoreHeroFeaturedContent';
export default CoreHeroFeaturedContent;
